import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Extrato } from '../../../models/extrato.model';
import { LinhaExtrato } from '../../../models/linhaExtrato.model';
import { ExtratoService } from '../../../services/importacao-extrato.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { TipoTransacao } from '../../../models/enums/tipoTransacao.enum';
import { Icones } from '../../../shared/variaveisDeRotas';
import { FormataValorPositivo } from '../../../helpers/formata-valor-positivo.helper';
import { PlanoDeContasService } from '../../../services/plano-de-contas.service';
import { SpinnerService } from '../../../services/spinner.service';

@Component({
  selector: 'app-detalhes-lista-extrato',
  templateUrl: './detalhes-lista-extrato.component.html',
  styleUrl: './detalhes-lista-extrato.component.scss'
})
export class DetalhesListaExtratoComponent implements OnInit {
  @Output() tituloChange = new EventEmitter<string>();
  @Output() iconeChange = new EventEmitter<string>();

  extrato: Extrato | null = null;
  linhasExtrato: LinhaExtrato[] = [];
  loading: boolean = false;

  constructor(
    private extratoService: ExtratoService,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService,
    public formataValorPositivoHelper: FormataValorPositivo,
    private planoDeContasService: PlanoDeContasService,
    private spinnerService: SpinnerService
  ) { }

  ngOnInit(): void {
    this.tituloChange.emit('Detalhes de Extrato bancário');
    this.iconeChange.emit(Icones.listaTopicoAmarelo);

    const extratoId = this.route.snapshot.paramMap.get('id');
    if (extratoId) {
      this.carregarExtrato(extratoId);
    } else {
      this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'ID do extrato não fornecido.' });
    }
  }

  carregarExtrato(id: string) {
    this.loading = true;
    this.spinnerService.show('Carregando extrato e contas contábeis...');
    this.extratoService.getExtratos().subscribe({
      next: (extratos: Extrato[]) => {
        const extratoEncontrado = extratos.find(e => e.id === id);
        if (extratoEncontrado) {
          this.extrato = extratoEncontrado;
          this.linhasExtrato = extratoEncontrado.linhasExtratos;

          const promises = this.linhasExtrato
            .filter(linha => linha.contaContabilId)
            .map(linha => {
              return this.planoDeContasService.obterPlanoDeConta(linha.contaContabilId).toPromise()
                .then(contaContabil => {
                  linha.descricaoContaContabil = contaContabil ? contaContabil.descricao : 'Conta contábil não encontrada';
                })
                .catch(() => {
                  linha.descricaoContaContabil = 'Erro ao buscar conta contábil';
                });
            });
          Promise.all(promises).finally(() => {
            this.loading = false;
            this.spinnerService.hide();
          });
        } else {
          this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Extrato não encontrado.' });
          this.loading = false;
          this.spinnerService.hide();
        }
      },
      error: (error) => {
        console.error('Erro ao carregar extrato:', error);
        this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Falha ao carregar extrato.' });
        this.loading = false;
        this.spinnerService.hide();
      }
    });
  }

  voltar() {
    this.router.navigate(['/lista-extrato']);
  }

  formatarDataOperacao(dataOperacao: string): Date | null {
    const [dia, mes, ano] = dataOperacao.split('-').map(part => parseInt(part, 10));

    if (dia && mes && ano) {
      return new Date(ano, mes - 1, dia);
    }

    return null;
  }
  getTipoTransacaoLabel(tipoTransacao: number): string {
    return TipoTransacao[tipoTransacao] || 'Desconhecido';
  }

}
